import { NOTIFICATION_BLOCK } from 'constants/MeshbotConstant';

export const buildNotificationBlockValue = (
    currentNotificationBlockFields,
    { channels, notificationBlock = {} } = {},
) => {
    const currentNotificationBlock = currentNotificationBlockFields.find(
        (field) => field.name === NOTIFICATION_BLOCK,
    )?.value;

    const updatedNotificationBlock = {
        ...currentNotificationBlock,
        ...notificationBlock,
    };

    if (channels?.includes('push') && channels?.length === 1) {
        delete updatedNotificationBlock.subject;
        delete updatedNotificationBlock.bodyHtml;
    }

    return updatedNotificationBlock;
};
